<template>
  <div
    id="createSellerAccount"
    class="container"
  >
    <section class="steps entry-steps" />
    <section class="formContainer">
      <div class="entry-card">
        <h2 class="entry-title">
          {{ $t('createSellerAccount.entry.title') }}
        </h2>
        <p class="entry-question">
          {{ $t('createSellerAccount.entry.question') }}
        </p>
        <div class="entry-options">
          <label
            class="entry-option"
            :class="{ active: selectedOption === 'has' }"
          >
            <input
              v-model="selectedOption"
              name="seller-entry-option"
              type="radio"
              value="has"
            >
            <div class="entry-option-content">
              <div class="entry-option-title">
              <span class="entry-option-en">
                {{ $t('createSellerAccount.entry.hasAccount') }}
              </span>
              </div>
              <div class="entry-option-desc">
              <span class="entry-option-en">
                {{ $t('createSellerAccount.entry.hasAccountDesc') }}
              </span>
              </div>
            </div>
          </label>
          <label
            class="entry-option"
            :class="{ active: selectedOption === 'none' }"
          >
            <input
              v-model="selectedOption"
              name="seller-entry-option"
              type="radio"
              value="none"
            >
            <div class="entry-option-content">
              <div class="entry-option-title">
              <span class="entry-option-en">
                {{ $t('createSellerAccount.entry.noAccount') }}
              </span>
              </div>
              <div class="entry-option-desc">
              <span class="entry-option-en">
                {{ $t('createSellerAccount.entry.noAccountDesc') }}
              </span>
              </div>
            </div>
          </label>
        </div>
        <div class="tc">
          <button
            type="button"
          class="myBtn sendCodeBtn entry-next"
            :disabled="!selectedOption"
            @click="handleNext"
          >
            {{ $t('createSellerAccount.next') }}
          </button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedOption: ''
    }
  },
  mounted() {
    this.resetSelection()
    this.applyKiliOauth2AutoSelect()
  },
  activated() {
    this.resetSelection()
    this.applyKiliOauth2AutoSelect()
  },
  methods: {
    resetSelection() {
      this.selectedOption = ''
    },
    applyKiliOauth2AutoSelect() {
      if (this.$route.query.kilioauth2 === 'true') {
        this.selectedOption = 'has'
        this.handleNext()
      }
    },
    async handleNext() {
      if (this.selectedOption === 'none') {
        sessionStorage.setItem('oauth_flow_enabled', '0')
        sessionStorage.removeItem('oauth_seller_info')
        sessionStorage.removeItem('oauth_seller_info_expire_at')
        this.$router.push('/create-seller-account/step1')
        return
      }
      if (this.selectedOption === 'has') {
        sessionStorage.setItem('oauth_flow_enabled', '1')
        sessionStorage.removeItem('oauth_seller_info')
        sessionStorage.removeItem('oauth_seller_info_expire_at')
        const redirectUri = this.getStep1RedirectUri()
        try {
          const response = await this.$axios.get('/oauth2/authorization-url', {
            params: {
              platform: 'kilimall',
              redirectUri
            }
          })
          if (Number(response.data.code) !== 0) {
            this.$Message.error(response.data.msg || 'Authorization failed')
            return
          }
          const authorizationUrl = response.data.data?.authorizationUrl
          if (!authorizationUrl) {
            this.$Message.error('Authorization url missing')
            return
          }
          window.location.href = authorizationUrl
        } catch (error) {
          console.error(error)
          this.$handleError(this, error)
        }
      }
    },
    getStep1RedirectUri() {
      const stepPath = this.$route.path.replace(/\/entry$/, '/step1')
      return `${window.location.origin}${stepPath}`
    }
  }
}
</script>

<style lang="scss" scoped>
#createSellerAccount {
  .steps {
    margin: 0.3rem 0;
  }
  .formContainer {
    margin: 0.5rem auto;
    padding: 0 290px;
  }
  .entry-card {
    padding: 0.5rem 0.6rem;
    border: 1px solid #ddd;
    border-radius: 6px;
    background: #fff;
  }
  .entry-title {
    text-align: center;
    font-size: 0.2rem;
    font-weight: 600;
    margin-bottom: 0.24rem;
  }
  .entry-question {
    text-align: center;
    font-size: 0.16rem;
    font-weight: 600;
    margin-bottom: 0.32rem;
  }
  .entry-options {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    margin-bottom: 0.4rem;
  }
  .entry-option {
    display: flex;
    align-items: flex-start;
    border: 1px solid #ddd;
    border-radius: 6px;
    padding: 0.2rem 0.24rem;
    cursor: pointer;
    transition: border-color 0.2s ease, background-color 0.2s ease;
    input {
      margin-right: 0.18rem;
      margin-top: 0.04rem;
    }
    &.active {
      border-color: $red;
      background-color: #fff5f5;
    }
  }
  .entry-option-title {
    display: flex;
    gap: 0.14rem;
    align-items: baseline;
    font-size: 0.14rem;
    font-weight: 600;
    margin-bottom: 0.1rem;
  }
  .entry-option-desc {
    font-size: 0.12rem;
    color: #777;
    line-height: 1.5;
  }
  .entry-option-en {
    color: #333;
  }
  .entry-next {
    min-width: 1.2rem;
  }
}
</style>
